<template lang="pug">
    v-row(justify="center" align="start").ma-4
        v-col(v-if="project" cols='12' md='8' xl='8')
            br
            div(justify="center" align="center")
                v-avatar
                    v-img(:src='getLogoPath($route.params.id)')
                br
                h1 {{ project.name }}
                  span(v-if="project.network == 'test'") &nbsp;Testnet

                go-back-button(:uri="'/'")

                v-chip(v-if="project.website.length > 0" small color="secondary" :href="project.website" target="_blank")
                  v-icon(left small) mdi-link-variant
                  span.text-truncate {{ project.website }}
                v-chip(v-for="validator in project.validator" small color="secondary" :href="validator.explorer" target="_blank")
                  v-icon(left small) mdi-account-check
                  span.text-truncate {{ validator.name }}
                v-chip(v-if="project.validator.length > 0 && project.validator[0].fee" small color="secondary" target="_blank")
                  v-icon(left small) mdi-credit-card
                  span.text-truncate {{ project.validator[0].fee }}%
                br
                br
            hr

        ToolsAndServices(v-if="project" :project="project")
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { get, values } from 'lodash';
import openbitlab from '@/types.d';
import ToolsAndServices from '@/components/SingleNetwork/ToolsAndServices.vue';
import GoBackButton from '@/components/SingleNetwork/GoBackButton.vue';

@Component({
  components: {
    ToolsAndServices, GoBackButton,
  },
})
export default class SingleNetworkView extends Vue {
  @State('projects') projects!: openbitlab.RootState['projects'];

  // eslint-disable-next-line
  public project: any = null; //openbitlab.Project;

  @Watch('projects', { immediate: true, deep: true })
  updatedProjects(projects: openbitlab.RootState['projects']) {
    this.project = this.projects[this.$route.params.id];
  }

  // eslint-disable-next-line class-methods-use-this
  getLogoPath(): string {
    const avatar = get(this.projects[this.$route.params.id], 'logo', 'none.png');
    return `/data/logos/${avatar}`;
  }
}
</script>
